<div *ngIf="product" class="h-100 flex flex-column flex-grow product-card"
    [class.selected]="selected"
>
    <div class="product-top-row flex flex-column full-width">
        <div class="product-video" *ngIf="product.video_url">
            <div class="overlay" (click)="openVideoModal()" (keydown.enter)="openVideoModal()" tabindex="0"></div>
            <!-- For Thumbnail only -->
            <app-iframe-video-player [url]="product.video_url">
            </app-iframe-video-player>
        </div>

        <div class="product-brochure" *ngIf="product.brochure_url">
            <button mat-button (click)="openBrochure()">
                📄 View Brochure
            </button>
        </div>

        <div tabindex="0"
             class="cursor-pointer"
             (click)="openProductDetails()"
             (keydown.enter)="openProductDetails()">
            <h6 class="product-type">{{ product.providerName }} - {{ product.productType }}</h6>
            <h4 class="product-name" [class.selected]="selected">{{ product.title }}</h4>
        </div>

        <div class="flex align-center justify-center product-add-icon" *ngIf="selected">
            <i class="fa-solid fa-check" aria-hidden="true"></i>
        </div>
    </div>

    <div class="product-bottom-row flex flex-column flex-grow">
        <div tabindex="0"
             appOverflowDetect
             overflowClass="overflowing"
             (click)="openProductDetails()"
             (keydown.enter)="openProductDetails()"
             class="flex justify-start full-width product-description cursor-pointer mb-3"
             *ngIf="product.description?.length">
            <div class="p2 lvl-1 m-0" [innerHTML]="product.description"></div>
        </div>

        <ul class="list-unstyled ps-3">
            <li *ngFor="let o of product.options"
                class="product-option"
                (click)="selectedProductIdChange.emit(o.id)"
                (keydown.enter)="selectedProductIdChange.emit(o.id)"
                tabindex="0"
            >
                <input
                    type="radio"
                    class="me-1"
                    [value]="o.id"
                    [(ngModel)]="selectedProductId"
                />
                <span>
                    {{ o.extra_data?.data | termMileMonth }}
                </span>
                <span class="opacity-50 text-nowrap">
                    [
                    <span>
                        {{ o.price | calculatePaymentWithSale: sale | currency:'USD':'symbol':'1.2-2' }}
                    </span>
                    <span class="caption" *ngIf="sale && sale.payment_frequency">
                         {{ sale.payment_frequency | paymentSuffix }}
                    </span>
                    ]
                </span>
            </li>
        </ul>

        <div class="flex flex-row justify-between align-end full-width pt-3 mt-auto">
            <div *ngIf="selectedProductId">
                <button class="button select-button" [class.remove]="selectedProductId" (click)="remove.emit()">
                    <div class="flex align-center justify-center icon">
                        <i class="fa-regular fa-trash" aria-hidden="true"></i>
                    </div>
                </button>
            </div>

            <div class="flex flex-column align-end" *ngIf="selectedProductId && selectedProduct">
                {{ selectedProduct.extra_data?.data | termMileMonth }}
                (Deductible: {{ selectedProduct.extra_data?.data?.deductibles?.[0]?.description }})
                <h3 class="m-0">
                    {{ (selectedProduct.price || 0) | calculatePaymentWithSale: sale | currency:'USD':'symbol':'1.2-2' }}
                </h3>
                <p class="caption lvl-1 m-0" *ngIf="sale && sale.payment_frequency">
                    {{ sale.payment_frequency | paymentSuffix }}
                </p>
            </div>
        </div>
    </div>
</div>
